(() => {
  if (window.saltiePressReady) return;
  window.saltiePressReady = true;

  const selector = '[data-saltie-press]';
  const logoSelector = '[data-saltie-press-logo]';

  const setActive = (section, index, { focus = false } = {}) => {
    const items = section.querySelectorAll('[data-saltie-press-item]');
    const logos = section.querySelectorAll(logoSelector);

    items.forEach((item) => {
      const isActive = Number(item.dataset.saltiePressItem) === index;
      item.classList.toggle('is-active', isActive);
      item.toggleAttribute('aria-hidden', !isActive);
    });

    logos.forEach((logo) => {
      const isActive = Number(logo.dataset.saltiePressLogo) === index;
      logo.setAttribute('aria-current', String(isActive));
      if (isActive && focus) logo.focus();
    });
  };

  const initSaltiePress = (section) => {
    if (section.dataset.saltiePressReady === 'true') return;
    section.dataset.saltiePressReady = 'true';

    const logos = Array.from(section.querySelectorAll(logoSelector));
    if (!logos.length) return;

    section.classList.add('saltie-press--enhanced');
    setActive(section, 0);

    section.addEventListener('click', (event) => {
      const logo = event.target.closest(logoSelector);
      if (!logo || !section.contains(logo)) return;

      setActive(section, Number(logo.dataset.saltiePressLogo));
    });

    section.addEventListener('keydown', (event) => {
      const logo = event.target.closest(logoSelector);
      if (!logo || !section.contains(logo)) return;

      const current = logos.indexOf(logo);
      let next = current;

      if (event.key === 'ArrowRight') next = (current + 1) % logos.length;
      if (event.key === 'ArrowLeft') next = (current - 1 + logos.length) % logos.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = logos.length - 1;
      if (next === current) return;

      event.preventDefault();
      setActive(section, Number(logos[next].dataset.saltiePressLogo), { focus: true });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(selector).forEach(initSaltiePress);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  }
})();
